const daysInARow = 7;
const todayBrowserDate = /* @__PURE__ */ new Date();
const defaultMinDate = /* @__PURE__ */ new Date("1970-01-01T00:00");
export {
  daysInARow,
  defaultMinDate,
  todayBrowserDate
};
//# sourceMappingURL=constants.js.map
